// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__rNVzH","colMaxWidth":"Table_colMaxWidth__3k0rM"};